import { observer } from 'mobx-react-lite'
import React, { useEffect, useMemo, useState } from 'react'
import { Alert, Button } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import type { AssignInboxStore } from 'entities/Phone/ui/actions/assignInbox/ui'
import { AssignInboxDefault } from 'entities/Phone/ui/actions/assignInbox/ui/ui/AssignInboxDefault/AssignInboxDefault'
import { BillingApi, PriceInfo, PriceInfoStore } from 'entities/Billing'
import styles from './styles.module.scss'

export const AssignInboxTwilioVendor = observer(
  ({ assignInboxStore }: { assignInboxStore: AssignInboxStore }) => {
    const entitiesContext = useEntitiesContext()
    const { subscriptionStore } = entitiesContext
    const priceInfoStore = useMemo(
      () =>
        new PriceInfoStore((count: number, cancelToken) =>
          BillingApi.getBillingPreview(
            {
              plan: entitiesContext.subscriptionStore.plan?.shared_inboxes_plan_id || '',
              numbers: Number.isNaN(count) ? 1 : count,
              use_unassigned_numbers: 0,
              use_bought_numbers: 0,
            },
            {
              cancelToken: cancelToken,
            }
          )
        ),
      []
    )

    const { disabledButton } = assignInboxStore

    const licensesCount = subscriptionStore.licensesCount
    const isNeedShowBillingInfo = licensesCount <= 0

    const [showBillingInfo, setShowBillingInfo] = useState(false)
    const [isReady, setReady] = useState(false)

    useEffect(() => {
      if (licensesCount) {
        setReady(true)
      } else {
        priceInfoStore
          .loadPriceData(1)
          .catch(console.error)
          .finally(() => setReady(true))
      }
    }, [licensesCount])

    const onNext = () => {
      setShowBillingInfo(true)
    }

    const onBack = () => {
      setShowBillingInfo(false)
    }

    return (
      <AssignInboxDefault
        assignInboxStore={assignInboxStore}
        disabledPrimary={!isReady}
        mainContent={
          showBillingInfo && (
            <div className={styles.wrapBillingInfo}>
              <PriceInfo priceInfoStore={priceInfoStore} labelPrefix='Number licenses' />
            </div>
          )
        }
        additionalContent={
          !isNeedShowBillingInfo && (
            <Alert
              marginTop={32}
              item={{
                type: 'infoBlue',
                title: 'You’ll not be charged for this number.',
                desc: `Your workspace has ${licensesCount} number license${
                  licensesCount > 1 ? 's' : ''
                } available.`,
              }}
            />
          )
        }
        secondaryButton={
          showBillingInfo && (
            <Button
              typeBtn={'contained'}
              text={'Back'}
              size={'medium'}
              contained={'secondary'}
              onClick={onBack}
            />
          )
        }
        primaryButton={
          isNeedShowBillingInfo &&
          !showBillingInfo && (
            <Button
              disabled={disabledButton}
              typeBtn={'contained'}
              text={'Next'}
              size={'medium'}
              onClick={onNext}
            />
          )
        }
      />
    )
  }
)
